import 'core-js/modules/es.object.assign.js';
import { jsx } from 'react/jsx-runtime';
import { useUtility } from '@hub-la/design-system';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';

const Fallback = ({
  isVideo: _isVideo = false
}) => {
  const {
    palette,
    isLight
  } = useUtility();
  return jsx("div", Object.assign({
    "data-testid": "thumbnail-fallback",
    style: {
      background: _isVideo ? palette(isLight ? 'surfaceAt4' : 'outline') : `linear-gradient(360deg, rgba(26, 28, 24, 1) 0%, rgba(26, 28, 24, 0.6) 100%)`,
      width: '100%',
      borderRadius: 4,
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, {
    children: _isVideo && jsx(ImageOutlinedIcon, {
      sx: {
        fontSize: 22
      }
    })
  }));
};

export { Fallback };
